import { Grid, TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { formatarInputValorMonetário } from "../../../../../helpers/masks";

export default function DadosSolicitacao() {

    const { control, getFieldState } = useFormContext();

    return (
        <Grid container spacing={2}>
            <Grid size={{xs: 12, md: 8}}>
                <Controller
                    name="dadosSolicitacao.valor"
                    control={control}
                    rules={{ required: 'Campo obrigatório' }}
                    render={({ field }) => (
                        <TextField
                            {...field}
                            label="Valor"
                            variant="outlined"
                            fullWidth
                            required
                            onChange={(e) => field.onChange(formatarInputValorMonetário(e.target.value))}
                            error={getFieldState('dadosSolicitacao.valor').invalid}
                            helperText={getFieldState('dadosSolicitacao.valor').error?.message || ""}
                        />
                    )}
                />
            </Grid>

            <Grid size={{xs: 12, md: 4}}>
                <Controller
                    name="dadosSolicitacao.prazo"
                    control={control}
                    rules={{ required: 'Campo obrigatório' }}
                    render={({ field }) => (
                        <TextField
                            {...field}
                            label="Prazo"
                            required
                            variant="outlined"
                            fullWidth
                            error={getFieldState('dadosSolicitacao.prazo').invalid}
                            helperText={getFieldState('dadosSolicitacao.prazo').error?.message || ""}
                        />
                    )}
                />
            </Grid>
            <Grid size={{xs: 12}}>
                <Controller
                    name="dadosSolicitacao.observacoes"
                    control={control}
                    render={({ field }) => (
                        <TextField
                            {...field}
                            label="Observações (opcional)"
                            multiline
                            rows={4}
                            fullWidth
                            error={getFieldState('dadosSolicitacao.observacoes').invalid}
                            helperText={getFieldState('dadosSolicitacao.observacoes').error?.message || ""}
                            placeholder="Digite aqui alguma informação adicional para incluir na mensagem"
                            variant="outlined"
                        />
                    )}
                />
            </Grid>
        </Grid>
    )
}